import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscribable } from 'rxjs';
import { first } from 'rxjs/operators';
import { CurBaseService } from './firebase/curbase.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  /**
    * Guarda la informacion del usuario.
  */
  public user;
  /**
    * Guarda el id de la empreza actual.
  */
  public empresaId;
  /**
    * Guarda la informacion de la empreza actual.
  */
  public empresa;
  /**
    * Guarda el id de la unidad privada actual en caso de existir.
  */
  public unidadId;
  /**
    * Guarda la informacion de la unidad privada actual en caso de existir.
  */
  public unidad;
  /**
    * Guarda un resumen de las empresas.
  */
  public empresas: {};
  /**
    * Subject de los datos basicos de la aplicacion.
  */
  private dataBS: BehaviorSubject<any>
  /**
    * Subscripcion de los datos basicos del usuario a firebase.
  */
  private userSubscription;
  /**
    * Subscripcion de la estructura de la empresa seleccionada a firebase.
  */
  private estructuraSubscription;

  /**
    * Subscripciones de los datos basicos de las empresas usuario a firebase.
  */
  private empresasSubscription;



  constructor(private dataS: CurBaseService, private storageS: StorageService) {
    console.log("Inicio constructor Global Data");
    this.dataBS = new BehaviorSubject({});
  }
  initData(user) {
      if (user) {
        if (!this.user || user.email !== this.user.email) {
          if (this.userSubscription)
            this.userSubscription.unsubscribe()
          this.userSubscription = this.dataS.getCollectionWhereFB('/personas', 'email', user.email).subscribe((us: any[]) => {
            if (us && us.length > 0) {
              this.user = us[0];
              this.publishData();
              console.log('global user ->', this.user);
              console.log("empresa seleccionada", this.defaultEmpresa())
              this.updateEmpresa(this.defaultEmpresa())
            }
            else {
              console.log("User don't exist")
              this.cleanData()
            }
          })
        }
      }
      else {
        console.log("Global User Logout")
        this.cleanData()
      }
  }
  updateEmpresa(empresa) {

    this.empresas = this.empresas || {};
    this.empresasSubscription = this.empresasSubscription || {};


    Object.keys(this.user.propiedades).forEach(key => {
      if (!this.empresasSubscription[key]) {
        this.empresas[key] = null
        let sub = this.dataS.getDocumentById('/empresas', key).subscribe(data => {
          this.empresas[key] = data
          console.log("empresas",this.empresas)
          if (this.empresaId == key) {
            this.empresa = this.empresa?{...this.empresa,data}: data;
            this.publishData();
          }
        })
        this.empresasSubscription[key] = sub
      }
    })

    if (empresa != this.empresaId) {
      this.empresaId = empresa
      this.empresa = this.empresas[empresa];
      this.storageS.writeSession("empresa", empresa)
      if (this.user.ultimaPropiedad!==empresa)
        this.dataS.actDocFb(this.user.id_reg, '/personas', { ultimaPropiedad: empresa })
      if (this.estructuraSubscription)
        this.estructuraSubscription.unsubscribe()
      this.estructuraSubscription = this.dataS.getCollectionFBIds(`/empresas/${empresa}/estructura`).subscribe(data => {
        this.empresa.estructura = data;
        this.publishData();
      })
    }
  }
  /**
     * Funcion para limpiar los objetos del servicio.
    */
  cleanData() {

    this.user=null;
    this.empresaId=null;
    this.empresa=null;
    this.unidadId=null;
    this.unidad=null;
    this.empresas=null;
    if (this.userSubscription){
      this.userSubscription.unsubscribe();
    };
    this.userSubscription=null;
    if (this.estructuraSubscription){
      this.estructuraSubscription.unsubscribe()
    }
    this.estructuraSubscription=null;
    if (this.empresasSubscription) {
      Object.keys(this.empresasSubscription).forEach(k => {
        this.empresasSubscription[k].unsubscribe()
      })
      this.empresasSubscription = null;
    }
    this.publishData()
  }
  /**
   * Funcion para publicar un nuevo mensaje en la subscripcion.
  */
  private publishData() {
    console.log("publishing data", {
      user: this.user,
      empresa: this.empresa
    })
    this.dataBS.next({
      user: this.user,
      empresa: this.empresa
    })
  }
  /**
   * Metodo para obtener un objeto al cual subscribirce y obtener
   * los datos actualizados del estado de la aplicacion
   *
   * @return un `Observable` que actualiza la informacion basica del usuario y empresa`.
  */
  getData(): Observable<{ user: any, empresa: any }> {
    return this.dataBS.asObservable()
  }

  private defaultEmpresa() {
    const session = this.storageS.readSession("empresa")
    console.log('session->',session);
    return session?session: this.empresaId?this.empresaId:this.user.ultimaPropiedad?this.user.ultimaPropiedad:Object.keys(this.user.propiedades).length > 0 ? Object.keys(this.user.propiedades)[0] : null
    // this.currentPH ? this.currentPH : this.user.ultimaPropiedad ? this.user.ultimaPropiedad : this.user.propiedades && Object.keys(this.user.propiedades).length > 1 ? null : Object.keys(this.user.propiedades)[0]
  }
}
